import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { HeaderThemeEnum, TopHeaderConfig } from '../../../models/header-model';

@Component({
  selector: 'ubs-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss']
})
export class TopHeaderComponent implements OnInit,OnChanges {
  @Input() topHeaderConfig:TopHeaderConfig;
  containsMainNav:boolean;
  background:string;
  color:string;

  host:HTMLElement;

  themeEnum:HeaderThemeEnum;

  constructor(private readonly viewRef: ViewContainerRef) { 
    this.host = this.viewRef.element.nativeElement;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["topHeaderConfig"]){
      //console.log({TopHeaderComponent:this.topHeaderConfig});
      this.themeEnum = this.topHeaderConfig.themeEnum?this.topHeaderConfig.themeEnum:HeaderThemeEnum.DEFAULT;
      this.setHeaderTheme(this.themeEnum);
      //let styles = this.host.style.setProperty("--")
      if(this.themeEnum == HeaderThemeEnum.CUSTOM && this.topHeaderConfig.background != undefined){
        this.background = this.topHeaderConfig.background;
        this.host.style.setProperty("--header-background-color",this.background);
      }
      if(this.themeEnum == HeaderThemeEnum.CUSTOM && this.topHeaderConfig.color != undefined){
        console.log("setting the color",this.topHeaderConfig.color);
        this.color = this.topHeaderConfig.color;
        this.host.style.setProperty("--header-text-color",this.color);
      }
    }
  }

  setHeaderTheme(themeEnum:HeaderThemeEnum){
    switch (themeEnum) {
      case HeaderThemeEnum.DEFAULT:
        //console.log("It's themeEnum")
        this.host.classList.add('main-default');
        if(this.host.classList.contains('main-dark')) {
          console.log("Removing main Dark")
          this.host.classList.remove('main-dark')
        };
        if(this.host.classList.contains('main-custom')) this.host.classList.remove('main-custom');
        break;
      case HeaderThemeEnum.CUSTOM:
        this.host.classList.add('main-custom');
        if(this.host.classList.contains('main-dark')) this.host.classList.remove('main-dark');
        if(this.host.classList.contains('main-default')) this.host.classList.remove('main-default');
        break;
      case HeaderThemeEnum.DARK:
        this.host.classList.add('main-dark');
        if(this.host.classList.contains('main-custom')) this.host.classList.remove('main-custom');
        if(this.host.classList.contains('main-default')) this.host.classList.remove('main-default');
        break;
      default:
        console.log("Holy shit")
        break;
    }
  }

}
